import { ManifestsActionTypes } from './constants';

type ManifestsAction = { type: string, payload: {} | string };

export const manifestsApiResponseSuccess = (actionType: string, data: any): ManifestsAction => ({
    type: ManifestsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const manifestsApiResponseError = (actionType: string, error: string): ManifestsAction => ({
    type: ManifestsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const manifestsGetAllManifests = (query, returnImage): ManifestsAction => ({
    type: ManifestsActionTypes.GET_ALL_MANIFESTS,
    payload: { query, returnImage },
});

export const manifestsCreateManifest = (manifestSpec, returnImage): ManifestsAction => ({
    type: ManifestsActionTypes.CREATE_MANIFEST,
    payload: { manifestSpec, returnImage },
});

export const manifestsCreateManifestForAllUnmanifested = (returnImage): ManifestsAction => ({
    type: ManifestsActionTypes.CREATE_MANIFEST_FOR_ALL_UNMANIFESTED,
    payload: { returnImage },
});

export const manifestsGetManifest = (manifestId, returnImage): ManifestsAction => ({
    type: ManifestsActionTypes.GET_MANIFEST,
    payload: { manifestId, returnImage },
});

export const manifestsResetState = (): ManifestsAction => ({
    type: ManifestsActionTypes.RESET_STATE,
    payload: {},
});

export const manifestsResetAllErrors = (): ManifestsAction => ({
    type: ManifestsActionTypes.RESET_ALL_ERRORS,
    payload: {},
})
